export default __webpack_public_path__ + "acc2e481e064c1d3957df8770d1b31cc.png";